module.exports = "\r\nul, li\r\n{\r\n    list-style: none;\r\n}"